export const textLength = (
  text: string,
  name: string,
  maxNumber: number,
  minNumber?: number
) => {
  let errMsg = undefined;

  if (text) {
    if (minNumber && text.length < minNumber) {
      errMsg = `The text must have a minimum of ${minNumber} characters.`;
    }

    if (text.length > maxNumber) {
      errMsg = `The text must have a maximum of ${maxNumber} characters.`;
    }
  } else {
    errMsg = `${name} field shouldn't be empty.`;
  }

  return errMsg;
};
